import { QueryClient, QueryKey, QueryObserver } from '@tanstack/react-query';

// This function is used to wait for the current mutations to finish before modifying the cache
// This can happen if you trying to optimistically update the cache with a query running
// See more information on this thread: https://github.com/TanStack/query/issues/3579
export async function waitForCurrentMutations(
    queryKey: QueryKey,
    queryClient: QueryClient,
) {
    const isCacheMutating =
        queryClient.getQueryState<any, any>(queryKey)?.fetchStatus ===
        'fetching';
    if (isCacheMutating) {
        await new Promise<void>((resolve) => {
            const observer = new QueryObserver(queryClient, { queryKey });
            const unsubscribe = observer.subscribe(({ isFetching }) => {
                // this is going to run when there's any update to the query
                if (!isFetching) {
                    unsubscribe();
                    resolve();
                }
            });
        });
    }
}
